/**
 * Created by Administrador on 10/28/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('faresController', faresController)
        .controller('newEditFareController', newEditFareController)
        .controller('deleteFareController', deleteFareController)
        .controller('modalAddPassengerController', modalAddPassengerController);

    faresController.$inject = ['fares', 'linkService', '$stateParams'];
    newEditFareController.$inject = ['loadForm', 'action', 'categoryService', 'linkService', 'fareService', '$uibModal',
        'currencies','$translate'];
    deleteFareController.$inject = ['fareId', 'fare', 'fareService', '$uibModalInstance'];
    modalAddPassengerController.$inject = ['passengerTypes','passengerTypesSelected','$uibModalInstance', '$translate',
        'linkService'];

    function faresController(fares, linkService, $stateParams) {
        var vm = this;
        vm.activeTypes = [
            {
                "id": true,
                "name": "Activos"
            },
            {
                "id": false,
                "name": "Inactivo"
            }
        ];
        vm.activeTypeId = $stateParams.active;
        vm.fares = (fares.data._embedded) ? fares.data._embedded.fares : [];
        vm.linkService = linkService;
        vm.pages = fares.data.page;

        vm.getActiveType = function(){
            if(vm.activeTypeId == null){
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: 0, size: 100, detailed: true, active: true});
            }else{
                linkService.reloadRoute(linkService.getCurrentRouteName(), {page: $stateParams.page, size: $stateParams.size, detailed:true, active: vm.activeTypeId});
            }
        }
    }

    function newEditFareController(loadForm, action, categoryService, linkService, fareService, $uibModal, currencies,$translate) {
        var vm = this;
        vm.rules = loadForm.data?loadForm.data._embeddeds.rule:[];
        vm.luggageRules = getLuggageRules(loadForm.data?loadForm.data._embeddeds.luggage:[]);
        vm.linkService = linkService;
        vm.action = action;

        vm.categories = loadForm.data._embeddeds.cabin;
        vm.fareScopes = loadForm.data._embeddeds.scopeFare;
        vm.flightTypes = loadForm.data._embeddeds.fareType;
        vm.calcTypes = loadForm.data._embeddeds.calculationType;
        vm.classes = [];
        vm.selectCheckBox = {};
        vm.selectCheckBoxAll = {};
        vm.selectCheckBoxLuggageAll = {};
        vm.selectCheckBoxLuggage = {};

        var urlTemplateBase = "app/admin/configGeneral/rates/fare/templates/";
        vm.fareTemplates = [
            {
                name: "passenger",
                template: urlTemplateBase + "passengerFare/passengerFare.html"
            },
            {
                name: "rule",
                template: urlTemplateBase + "ruleFare/ruleFare.html"
            },
            {
                name: "luggageRule",
                template: urlTemplateBase + "luggageRuleFare/luggageRuleFare.html"
            }
        ];

        vm.currencies = currencies;
        for (var i = 0; i < vm.currencies.length; i++){
            vm.currencies[i].currencyId = parseInt(linkService.getLinkId(vm.currencies[i]._links.self.href));
        }

        vm.getClass = function (cabin) {
            if (cabin != undefined) {
                categoryService.getClassesByCategory(linkService.getLinkId(cabin._links.self.href))
                    .then(function (response) {
                        vm.classes = (response.data._embedded) ? response.data._embedded.fareClasses : [];
                    });
            } else {
                vm.classes = [];
            }
        };

        if(vm.action == "new"){
            vm.fare = {
                active: true,
                passengerTypes: [],
                existsPassenger: '',
                existsRules: (vm.rules.length==0?'':'exists'),
                existsLuggageRules: (vm.luggageRules.length==0?'':'exists'),
                openSale: false
            }
        }else{
            var fareLoadForm = loadForm.data._embeddeds.fare;
            vm.fareId = linkService.getLinkId(fareLoadForm._links.self.href);
            vm.fare = {
                cabin: fareLoadForm._embedded.category,
                class: fareLoadForm._embedded.class,
                name: fareLoadForm.name,
                fareTradeName: fareLoadForm.fareTradeName,
                currencyId: fareLoadForm.currencyId,
                flightType: fareLoadForm._embedded.flightType,
                scope: fareLoadForm._embedded.fareScope,
                active: fareLoadForm.active,
                openSale: fareLoadForm.openSale,
                remark: fareLoadForm.remark,
                rules: fareLoadForm._embedded.rules,
                passengerTypes: fareLoadForm._embedded.farePassengerTypes,
                existsPassenger: (fareLoadForm._embedded.farePassengerTypes.length==0?'':'exists'),
                existsRules: (vm.rules.length==0?'':'exists'),
                existsLuggageRules: (vm.luggageRules.length==0?'':'exists'),
                luggageRules: fareLoadForm._embedded.luggages
            }
            vm.getClass(vm.fare.cabin);
            vm.selectCheckBox = getSelectCheckBox(vm.fare.rules, vm.selectCheckBox, linkService);
            vm.selectCheckBoxLuggage = getSelectCheckBox(vm.fare.luggageRules, vm.selectCheckBoxLuggage, linkService);
        }

        vm.handleRegulation = function (regulation) {
            if (regulation.type == "passengerTypeRule") {
                return vm.handlePassengerTypeItems(regulation);
            } else if (regulation.type == "dateRule") {
                return vm.handleDateRule(regulation);
            } else if (regulation.type == "minMaxStayRule") {
                return vm.handleMinMaxStayRule(regulation);
            } else if (regulation.type == "bookingTicketingRule") {
                return vm.handleBookingTicketingRule(regulation);
            } else if (regulation.type == "saleChannelRule") {
                return vm.handleSaleChannelRule(regulation);
            } else if (regulation.type == "temporalityRule") {
                return vm.handlePeriodDates(regulation);
            } else if (regulation.type == "penaltyRule") {
                return vm.handlePenaltyItems(regulation);
            } else if (regulation.type == "flightRouteRule") {
                return vm.handleFlightRuleItems(regulation);
            }
        };

        vm.handlePassengerTypeItems = function (regulation) {
            vm.passengerTypeItemsText = [];
            angular.forEach(regulation._embedded.passengerTypeItems, function (passengerTypeItems, index) {
                vm.passengerTypeItemsText = vm.passengerTypeItemsText + passengerTypeItems.passengerTypeId + ", ";
            });

            return vm.passengerTypeItemsText = {
                "name": "air.fare.rules.regulationsName.passengerTypeItems",
                "data": vm.passengerTypeItemsText.substring(0, vm.passengerTypeItemsText.length - 2)
            };
        };
        vm.handleDateRule = function (regulation) {
            return vm.dateRuleText = {
                "name": "air.fare.rules.regulationsName.dateRule",
                "data": moment(regulation._embedded.dateRule.publicationDate).format('DD MMM YYYY')
            };
        };
        vm.handleMinMaxStayRule = function (regulation) {
            return vm.minMaxStayRuleText = {
                "name": "air.fare.rules.regulationsName.minMaxStayRule",
                "data": regulation._embedded.minMaxStayRule.noLessThanType+" - "+
                regulation._embedded.minMaxStayRule.noLessThanValue+" ,"+
                regulation._embedded.minMaxStayRule.noMoreThanType+" - "+
                regulation._embedded.minMaxStayRule.noMoreThanValue
            }
        };
        vm.handleBookingTicketingRule = function (regulation) {
            return vm.bookingTicketingRuleText = {
                "name": "air.fare.rules.regulationsName.bookingTicketingRule",
                "data": regulation._embedded.bookingTicketingRule.minBookBeforeDeparture+" ,"+
                regulation._embedded.bookingTicketingRule.minSaleBeforeDeparture
            }
        };
        vm.handleSaleChannelRule = function (regulation) {
            return vm.saleChanelRuleText = {
                "name": "air.fare.rules.regulationsName.saleChannelRule",
                "data": regulation._embedded.saleChannelRule.promotionalCode
            }
        };
        vm.handlePeriodDates = function (regulation) {
            vm.periodDatesText = [];
            angular.forEach(regulation._embedded.periodDates, function (periodDates, index) {
                vm.periodDatesText = vm.periodDatesText + periodDates.startPeriod + ", ";
            });

            return vm.passengerTypeItemsText = {
                "name": "air.fare.rules.regulationsName.periodDates",
                "data": vm.periodDatesText.substring(0, vm.periodDatesText.length - 2)
            };
        };
        vm.handlePenaltyItems = function (regulation) {
            vm.penalityItemsText = [];
            angular.forEach(regulation._embedded.penaltyItems, function (penaltyItem, index) {
                vm.penalityItemsText = vm.penalityItemsText + penaltyItem.code + '-' + penaltyItem.fixedAmount + ', ' + penaltyItem.percentage + '% ' + ", ";
            });

            return vm.penalityItemsText = {
                "name": "air.fare.rules.regulationsName.penaltyItems",
                "data": vm.penalityItemsText.substring(0, vm.penalityItemsText.length - 2)
            };
        };
        vm.handleFlightRuleItems = function (regulation) {
            vm.flightRuleText = [];
            var flightRuleItemsAux = regulation._embedded.flightRouteRule._embedded?
                regulation._embedded.flightRouteRule._embedded.flightRuleItems : [];
            angular.forEach(flightRuleItemsAux, function (flightRuleItems, index) {
                vm.flightRuleText = vm.flightRuleText + flightRuleItems.originIataCode + ", ";
            });

            return vm.flightRuleText = {
                "name": "air.fare.rules.regulationsName.flightRuleItems",
                "data": vm.flightRuleText.length > 0?vm.flightRuleText.substring(0, vm.flightRuleText.length - 2):''
            };
        };

        vm.handleCheckBoxRuleAll = function () {
            if (vm.selectCheckBoxAll['0'] !== undefined && vm.selectCheckBoxAll['0']) {
                angular.forEach(vm.rules, function (rule) {
                    vm.selectCheckBox[parseInt(linkService.getLinkId(rule._links.self.href))] = true;
                });
            } else {
                angular.forEach(vm.rules, function (rule) {
                    vm.selectCheckBox[parseInt(linkService.getLinkId(rule._links.self.href))] = false;
                });
            }
        }

        vm.handleCheckBoxLuggageAll = function () {
            if (vm.selectCheckBoxLuggageAll['0'] !== undefined && vm.selectCheckBoxLuggageAll['0']) {
                angular.forEach(vm.luggageRules, function (luggageRule) {
                    vm.selectCheckBoxLuggage[parseInt(linkService.getLinkId(luggageRule._links.self.href))] = true;
                });
            } else {
                angular.forEach(vm.luggageRules, function (luggageRule) {
                    vm.selectCheckBoxLuggage[parseInt(linkService.getLinkId(luggageRule._links.self.href))] = false;
                });
            }
        }

        vm.handleCheckBoxRule = function () {
            vm.handleCheckBox('selectCheckBox', 'selectCheckBoxAll', vm.rules.length, vm);
        }

        vm.handleCheckBoxLuggage = function () {
            vm.handleCheckBox('selectCheckBoxLuggage', 'selectCheckBoxLuggageAll', vm.luggageRules.length, vm);
        }

        vm.handleCheckBox = function (selectCheckBox, selectCheckBoxAll, checkBoxesLength, vm) {
            var contCheckBox = 0;
            var cont =  checkBoxesLength;
            angular.forEach(vm[selectCheckBox], function (index, value) {
                if (index === true){
                    contCheckBox++;
                }
            });

            if (contCheckBox === 0) {
                vm[selectCheckBoxAll] = {"0": false};
            } else if (contCheckBox > 0 && contCheckBox !== cont) {
                vm[selectCheckBoxAll] = {"0": false};
            } else if (contCheckBox === cont) {
                vm[selectCheckBoxAll] = {"0": true};
            }
        }

        vm.addPassenger = function(){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/fare/modalAddPassenger.html',
                controller: 'modalAddPassengerController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['passengerType']);
                    }],
                    passengerTypes: ['passengerTypeService', function(passengerTypeService){
                        return passengerTypeService.getPassengerTypes();
                    }],
                    passengerTypesSelected: [function(){
                        return vm.fare.passengerTypes;
                    }]
                }
            }).result.then(function(responses) {
                angular.forEach(responses, function(response){
                    vm.fare.passengerTypes.push(response);
                });
                vm.fare.existsPassenger = (vm.fare.passengerTypes.length==0?'':'exists')
            }, function() {
                //$state.go('^');
            });
        }

        vm.deletePassengerType = function(index){
            vm.fare.passengerTypes.splice(index, 1);
            vm.fare.existsPassenger = (vm.fare.passengerTypes.length==0?'':'exists');
        }

        vm.saveFare = function (isValid, fare) {
            var save = {
                "active": fare.active,
                "openSale": fare.openSale,
                "classId": parseInt(linkService.getLinkId(fare.class._links.self.href)),
                "currencyId": fare.currencyId,
                "flightType": fare.flightType.code,
                "name": fare.name,
                "fareTradeName": fare.fareTradeName,
                "remark": fare.remark,
                "rules": rulesIds(vm.selectCheckBox),
                "scope": fare.scope.code,
                "tradeName": fare.cabin.iataCode,
                "rbcFarePassengerTypes": vm.fare.passengerTypes,
                "luggages": rulesIds(vm.selectCheckBoxLuggage)
            }

            if (isValid) {
                if(vm.action == "new"){
                    fareService.saveFare(save);
                }else{
                    fareService.updateFare(vm.fareId, save);
                }
            }
        };

        function handleLuggageSegments(segmentLuggages) {
            var luggageSegmentText = "";
            angular.forEach(segmentLuggages, function (segmentLuggage) {
                luggageSegmentText = luggageSegmentText + segmentLuggage._embedded.segment.initials + ' | ';
            });

            return {
                "name": "air.luggageRule.table.luggageRuleNames.segment",
                "data": luggageSegmentText.substring(0, luggageSegmentText.length - 2)
            };
        };

        function handleLuggageFranchises(franchiseLuggages) {
            var luggageFranchiseText = "";
            angular.forEach(franchiseLuggages, function (franchiseLuggage) {
                luggageFranchiseText = luggageFranchiseText + 'ADT '+(franchiseLuggage.weightPerUnit * franchiseLuggage.freeFranchise) + ' kgs, ';
            });

            return {
                "name": "air.luggageRule.franchise.freeFranchise",
                "data": luggageFranchiseText.substring(0, luggageFranchiseText.length - 2)
            };
        };

        function handleLuggageExcess(excessLuggages) {
            var luggageExcessText = "";
            angular.forEach(excessLuggages, function (excessLuggage) {
                luggageExcessText = luggageExcessText + $translate.instant(excessLuggage._embedded.excessLuggageType.lang)+' '+excessLuggage.amount + ', '
            });

            return {
                "name": "air.luggageRule.excess.luggageExcess",
                "data": luggageExcessText.substring(0, luggageExcessText.length - 2)
            };
        };

        function handleLuggageRules(regulation) {
            var handleLuggageRules = [];
            handleLuggageRules.push(handleLuggageSegments(regulation.segmentLuggages));
            handleLuggageRules.push(handleLuggageFranchises(regulation.franchiseLuggages));
            handleLuggageRules.push(handleLuggageExcess(regulation.excessLuggages));
            return handleLuggageRules;
        };

        function getLuggageRules(luggageRules){
            angular.forEach(luggageRules, function(luggageRule){
                luggageRule.handleLuggageRules = handleLuggageRules(luggageRule._embedded);
            });
            return luggageRules;
        }
    }

    function deleteFareController(fareId, fare, fareService, $uibModalInstance) {
        var vm = this;

        vm.name = fare.data.name;

        vm.deleteFare = function () {
            fareService.deleteFare(fareId)
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalAddPassengerController(passengerTypes, passengerTypesSelected,$uibModalInstance, $translate, linkService){
        var vm = this;
        vm.passengerTypes = (passengerTypes.data._embedded) ? passengerTypes.data._embedded.passengerTypes : [];
        vm.passengerTypesTree = refactorJson(vm.passengerTypes, passengerTypesSelected, $translate, linkService);
        vm.treeConfig = getTreeConfig();
        vm.treeInstance = {};
        vm.passengerType = {
            ids: ""
        };

        vm.selectedPassenger = function () {
            var selects = vm.treeInstance.jstree(true).get_selected();
            if(selects.length > 0){
                vm.passengerType.ids = "ids";
            }else{
                vm.passengerType.ids = "";
            }
        }

        vm.getPassengerType = function(id){
            var passenger = null;
            for (var i = 0; i < vm.passengerTypes.length; i++){
                if(linkService.getLinkId(vm.passengerTypes[i]._links.self.href) == id){
                    passenger = vm.passengerTypes[i];
                    break;
                }
            }
            return passenger;
        }

        vm.addPassengerType = function(isValid){
            if(isValid){
                var passengerTypeIds = vm.treeInstance.jstree(true).get_selected();
                var data = [];
                for(var i = 0; i < passengerTypeIds.length; i++){
                    if(passengerTypeIds[i] != "2000" && passengerTypeIds[i] != "2001" && passengerTypeIds[i] != "2002"){
                        data.push({
                            fixedAmount: 0,
                            id: 0,
                            passengerTypeId: parseInt(passengerTypeIds[i]),
                            percentage: 0,
                            type: "",
                            _embedded: {
                                passengerType: vm.getPassengerType(passengerTypeIds[i])
                            }
                        });
                    }
                }
                $uibModalInstance.close(data);
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function getSelectCheckBox(rules, selectCheckBox, linkService){
        angular.forEach(rules, function (rule) {
            selectCheckBox[parseInt(linkService.getLinkId(rule._links.self.href))] = true;
        });
        return selectCheckBox;
    }

    function rulesIds(selectCheckBox){
        var ruleIds = [];
        angular.forEach(selectCheckBox, function (index, value) {
            if (index==true){
                ruleIds.push(value);
            }
        });
        return ruleIds;
    }

    function refactorJson(passengerTypes, passengerTypesSelected, $translate, linkService){
        var data = [];
        var bandAdt = false;
        var bandChd = false;
        var bandInf = false;

        angular.forEach(passengerTypes, function(passengerType){
            var parent = 0;
            var existsPassenger = passengerTypesSelected.length==0? false :
                existsPassengerId(linkService.getLinkId(passengerType._links.self.href),passengerTypesSelected);
            if(!existsPassenger) {
                if (passengerType.group == "adult") {
                    parent = 2000;
                    bandAdt = true;
                } else {
                    if (passengerType.group == "child") {
                        parent = 2001;
                        bandChd = true;
                    } else {
                        parent = 2002;
                        bandInf = true;
                    }
                }

                data.push({
                    "id": linkService.getLinkId(passengerType._links.self.href),
                    "parent": parent,
                    "text": $translate.instant(passengerType.lang),
                    "state": {
                        "opened": true
                    }
                });
            }
        });
        if(bandAdt){
            data.push({"id": 2000, "parent": "#", "text": $translate.instant("air.passengerType.adults"), "state": { "opened": true}});
        }
        if(bandChd){
            data.push({"id": 2001, "parent": "#", "text": $translate.instant("air.passengerType.children"), "state": { "opened": true}});
        }
        if(bandInf){
            data.push({"id": 2002, "parent": "#", "text": $translate.instant("air.passengerType.infants"), "state": { "opened": true }});
        }

        return data;
    }

    function getTreeConfig(){
        return {
            core : {
                multiple : true,
                animation: true,
                error : function(error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback : true,
                worker : true,
                themes: {
                    "icons": false
                }
            },
            types : {
                default : {
                    icon : 'fa fa-square-o'
                },
                star : {
                    icon : 'fa fa-check-square-o'
                },
                cloud : {
                    icon : 'fa fa-check-square-o'
                }
            },
            plugins : ['types', 'checkbox']
        }
    }

    function existsPassengerId(passengerId, passengerTypesSelected){
        var res = false;

        for(var i=0; i<passengerTypesSelected.length; i++){
            if(passengerId == passengerTypesSelected[i].passengerTypeId){
                res = true;
                break;
            }
        }
        return res;
    }
})();
